export const DASHBOARD_LIST_REQUEST = "DASHBOARD_LIST_REQUEST";
export const DASHBOARD_LIST_SUCCESS = "DASHBOARD_LIST_SUCCESS";
export const DASHBOARD_LIST_FAIL = "DASHBOARD_LIST_FAIL";

export const DASHBOARD_ORDER_LIST_REQUEST = "DASHBOARD_ORDER_LIST_REQUEST";
export const DASHBOARD_ORDER_LIST_SUCCESS = "DASHBOARD_ORDER_LIST_SUCCESS";
export const DASHBOARD_ORDER_LIST_FAIL = "DASHBOARD_ORDER_LIST_FAIL";
